// Single source of truth for FAQ content — used by the homepage FAQ strip
// and the dedicated /faq page (each renders schema that matches its visible content).
export const FAQS = [
  {
    q: "What is a liquid culture and why start with one?",
    a: "A liquid culture (LC) is live mushroom mycelium suspended in a sterile nutrient broth. Because the mycelium is already germinated and genetically consistent, it colonizes grain and substrate faster and more reliably than spores — giving you a cleaner, quicker path to fruiting.",
  },
  {
    q: "Are your mushroom cultures lab-tested for contamination?",
    a: "Yes. Every NC Mycology liquid culture is isolated on agar, propagated in a HEPA-filtered lab, and sterility-tested before it ships. We only sell cultures clean enough to use in our own grows.",
  },
  {
    q: "How do I prevent contamination when growing mushrooms?",
    a: "Contamination almost always traces back to four fixable things: incomplete sterilization of grain, inoculating in moving or dirty air, letting sterilized jars cool in a contaminated space, and starting from a weak culture. Work in still, sanitized air with gloves, fully sterilize your grain, cool jars in a clean area, and always begin with a lab-tested culture.",
  },
  {
    q: "How fast do orders ship?",
    a: "Orders are prepared fresh and typically ship within 1-3 business days from North Carolina, with tracking provided. Digital guides and ebooks are delivered instantly as a download after checkout.",
  },
  {
    q: "Do you have products for complete beginners?",
    a: "Yes. All-in-one inoculated grow bags and 5-gallon bucket kits let you fruit mushrooms with no prior experience, and our step-by-step cultivation guides (including a free 'Build Your Own Mycology Lab' download) walk you through every stage.",
  },
  {
    q: "What is your return and refund policy?",
    a: "Because cultures are perishable, living biological products, we stand behind their sterility and viability on arrival — if anything arrives damaged or contaminated, contact us right away with photos and we'll make it right. See our Refund Policy page for full details.",
  },
  {
    q: "Where do you ship and are there discounts?",
    a: "We ship across the United States. New customers get 10% off with code GROW10, email subscribers get 15%, and verified military members and first responders receive 20% off — just reach out for your code.",
  },
  {
    q: "How long does a liquid culture syringe last?",
    a: "Stored upright in a cool, dark place (a refrigerator is ideal, but avoid freezing), a sealed liquid culture syringe generally stays viable for 6-12 months. Always sanitize the luer-lock tip and needle before each use.",
  },
  {
    q: "What's the difference between liquid culture and a spore syringe?",
    a: "A spore syringe contains ungerminated spores with mixed genetics that must first germinate — slower and more variable. A liquid culture is already-living, cloned mycelium of a single proven strain, so it colonizes faster, more predictably, and with less contamination risk.",
  },
  {
    q: "Which mushrooms are easiest for a first grow?",
    a: "Oyster mushrooms (Blue, Pearl, Pink) are the most forgiving and fast for beginners, followed by Lion's Mane. They tolerate a range of conditions and fruit quickly, which makes them ideal first strains before moving on to Shiitake or medicinals like Reishi.",
  },
  {
    q: "Do I need special equipment to use a liquid culture?",
    a: "For basic use you only need sterilized grain or an all-in-one grow bag, 70% isopropyl alcohol, a lighter or torch to flame the needle, and clean hands or gloves. A still-air box or flow hood improves your success rate but isn't required to get started.",
  },
];
